type GridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

export const numberToGridEnum = (number: number): GridSize => {
  switch (true) {
    case number >= 1 && number < 2:
      return 1
    case number >= 2 && number < 3:
      return 2
    case number >= 3 && number < 4:
      return 3
    case number >= 4 && number < 5:
      return 4
    case number >= 5 && number < 6:
      return 5
    default:
      return 6
  }
}
